import { render, staticRenderFns } from "./variation_info.vue?vue&type=template&id=516c92b2&"
import script from "./variation_info.vue?vue&type=script&lang=js&"
export * from "./variation_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports